import { Skeleton as MuiSkeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SkeletonCircleProps, SKELETON_ANIMATION } from '../Skeleton.types';
import { getSkeletonBackgroundColor } from '../styleUtils';

const DEFAULT_SIZE = 40;

export const SkeletonCircle = ({ size = DEFAULT_SIZE, sx }: SkeletonCircleProps) => {
    const theme = useTheme();

    return (
        <MuiSkeleton
            variant="circular"
            width={size}
            height={size}
            animation={SKELETON_ANIMATION}
            sx={{
                backgroundColor: getSkeletonBackgroundColor(theme),
                ...sx,
            }}
        />
    );
};
